export default __webpack_public_path__ + "static/media/home-restaurant-bg-01.06192e98.jpg";